module.exports = __webpack_public_path__ + "img/public/SiteIcons/scanIconWhite.svg?af4d30b3";